class SidebarPopovers {
    constructor() {
        const sidebarEl = document.getElementById('kt_app_sidebar');
        const bodyEl = document.getElementsByTagName('body')[0];
        if(sidebarEl && bodyEl){
            const popoverTriggerList = [].slice.call(sidebarEl.querySelectorAll('.menu-link[data-bs-toggle="sidebar-popover"]'));
            if(bodyEl.getAttribute("data-kt-app-sidebar-minimize") === 'on'){
                popoverTriggerList.map(function (popoverTriggerEl) {
                    bootstrap.Popover.getOrCreateInstance(popoverTriggerEl);
                });
            }
            const mutationCallback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type !== "attributes" || mutation.attributeName !== "data-kt-app-sidebar-minimize") {
                        return;
                    }
                    if(mutation.target.getAttribute("data-kt-app-sidebar-minimize") === 'on'){
                        popoverTriggerList.map(function (popoverTriggerEl) {
                            bootstrap.Popover.getOrCreateInstance(popoverTriggerEl);
                        });
                    } else {
                        popoverTriggerList.map(function (popoverTriggerEl) {
                            bootstrap.Popover.getOrCreateInstance(popoverTriggerEl).dispose();
                        });
                    }
                }
            }
            const observer = new MutationObserver(mutationCallback);
            observer.observe(document.getElementsByTagName('body')[0], { attributes: true });
        }
    }
}

// Enable/Disable left menu popovers if the left menu is minimized
KTUtil.onDOMContentLoaded(function () {
    new SidebarPopovers();
});